import { render, staticRenderFns } from "./InscriptionsGraphs.vue?vue&type=template&id=5648b0e3"
import script from "./InscriptionsGraphs.vue?vue&type=script&lang=js"
export * from "./InscriptionsGraphs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports